import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";

// Novedades del catálogo para supervisoras: productos nuevos y quitados de esta
// semana y de la anterior, por día de actualización. Tarjeta discreta (en
// Supervisora → Compras) que abre una ventana; "Entendido" marca todo como visto.
// Separado de la campana de cambios de pisos.

const DIA = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
const MES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
const tituloDia = (iso) => {
  const [y, m, d] = iso.split("-").map(Number);
  const f = new Date(y, m - 1, d);
  const hoy = new Date();
  const ayer = new Date(); ayer.setDate(hoy.getDate() - 1);
  const mismo = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  const txt = `${DIA[f.getDay()]} ${d} de ${MES[m - 1]}`;
  if (mismo(f, hoy)) return `Hoy · ${txt}`;
  if (mismo(f, ayer)) return `Ayer · ${txt}`;
  return txt.charAt(0).toUpperCase() + txt.slice(1);
};
const fmtFecha = (iso) => `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
const fmtPrecio = (p) => (p === null || p === undefined || p === "" ? "" : `${Number(p).toFixed(2).replace(".", ",")} €`);
// mismo formato que en Crear compra ("Cantidad: {cantidad}kg")
const fmtCantidad = (c) => (c === null || c === undefined || c === "" ? "" : `${c}kg`);

export const EVENTO_NOVEDADES = "novedades-productos";

const Producto = ({ p, quitado }) => (
  <div style={{
    display: "flex", gap: 10, alignItems: "center", padding: "7px 8px", borderRadius: 10,
    background: quitado ? "#fef2f2" : "#f0fdf4", border: `1px solid ${quitado ? "#fecaca" : "#bbf7d0"}`,
  }}>
    {p.imagen ? (
      <img src={p.imagen} alt="" loading="lazy" style={{
        width: 46, height: 46, objectFit: "contain", borderRadius: 8, background: "#fff", flexShrink: 0,
        filter: quitado ? "grayscale(1)" : "none", opacity: quitado ? 0.6 : 1,
      }} />
    ) : <div style={{ width: 46, height: 46, borderRadius: 8, background: "#fff", flexShrink: 0 }} />}
    <div style={{ minWidth: 0, flex: 1 }}>
      <div style={{ fontWeight: 700, fontSize: 14, color: "#1e293b", textDecoration: quitado ? "line-through" : "none", lineHeight: 1.25 }}>
        {p.nombre}
      </div>
      <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
        {[p.categoria, fmtCantidad(p.cantidad), fmtPrecio(p.precio)].filter(Boolean).join(" · ")}
      </div>
    </div>
  </div>
);

const BloqueDia = ({ d, abiertoInicial }) => {
  const [abierto, setAbierto] = useState(abiertoInicial);
  return (
    <div style={{ border: "1px solid #e2e8f0", borderRadius: 14, marginBottom: 10, overflow: "hidden" }}>
      <button onClick={() => setAbierto((v) => !v)} style={{
        width: "100%", display: "flex", alignItems: "center", gap: 8, padding: "11px 12px", border: "none",
        background: "#f8fafc", cursor: "pointer", textAlign: "left",
      }}>
        <span style={{ flex: 1, fontWeight: 800, fontSize: 14.5, color: "#1e293b" }}>📅 {tituloDia(d.dia)}</span>
        {d.altas.length > 0 && <span style={{ background: "#dcfce7", color: "#15803d", borderRadius: 999, padding: "2px 9px", fontSize: 12.5, fontWeight: 800 }}>+{d.altas.length}</span>}
        {d.bajas.length > 0 && <span style={{ background: "#fee2e2", color: "#b91c1c", borderRadius: 999, padding: "2px 9px", fontSize: 12.5, fontWeight: 800 }}>−{d.bajas.length}</span>}
        <span style={{ color: "#64748b", transition: "transform .2s", transform: abierto ? "rotate(180deg)" : "none" }}>▾</span>
      </button>
      {abierto && (
        <div style={{ padding: "10px 12px 12px" }}>
          {d.altas.length > 0 && (
            <>
              <div style={{ fontWeight: 800, color: "#15803d", fontSize: 13.5, margin: "2px 0 8px" }}>🟢 Nuevos ({d.altas.length})</div>
              <div style={{ display: "grid", gap: 6, marginBottom: d.bajas.length ? 14 : 0 }}>
                {d.altas.map((p, i) => <Producto key={`a${p.id_producto}-${i}`} p={p} />)}
              </div>
            </>
          )}
          {d.bajas.length > 0 && (
            <>
              <div style={{ fontWeight: 800, color: "#b91c1c", fontSize: 13.5, margin: "2px 0 8px" }}>🔴 Quitados ({d.bajas.length})</div>
              <div style={{ display: "grid", gap: 6 }}>
                {d.bajas.map((p, i) => <Producto key={`b${p.id_producto}-${i}`} p={p} quitado />)}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default function NovedadesProductos() {
  const [datos, setDatos] = useState(null);
  const [abierto, setAbierto] = useState(false);
  const [guardando, setGuardando] = useState(false);

  const cargar = useCallback(() => {
    axios.get("/api/productos/novedades").then((r) => setDatos(r.data)).catch(() => setDatos(null));
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  if (!datos) return null;
  const dias = datos.dias || [];
  const esta = dias.filter((d) => d.semana === "esta");
  const anterior = dias.filter((d) => d.semana === "anterior");
  const total = (lista, k) => lista.reduce((s, d) => s + d[k].length, 0);
  const pendientes = datos.pendientes || 0;
  const nAltas = total(esta, "altas"), nBajas = total(esta, "bajas");
  const nAltasAnt = total(anterior, "altas"), nBajasAnt = total(anterior, "bajas");
  // sin cambios en las dos semanas: no se enseña nada (no cargar la pantalla)
  if (!nAltas && !nBajas && !nAltasAnt && !nBajasAnt) return null;
  const miniaturas = esta.flatMap((d) => d.altas).filter((p) => p.imagen).slice(0, 4);

  const entendido = async () => {
    setGuardando(true);
    try { await axios.post("/api/productos/novedades/visto"); } catch (_) {}
    setGuardando(false);
    setAbierto(false);
    setDatos((d) => ({ ...d, pendientes: 0 }));
    window.dispatchEvent(new Event(EVENTO_NOVEDADES));
  };

  const Semana = ({ titulo, lista }) => (
    <div style={{ marginBottom: 14 }}>
      <div style={{ fontSize: 13, fontWeight: 900, color: "#475569", textTransform: "uppercase", letterSpacing: 0.3, margin: "4px 2px 8px" }}>
        {titulo} · <span style={{ color: "#15803d" }}>+{total(lista, "altas")}</span> <span style={{ color: "#b91c1c" }}>−{total(lista, "bajas")}</span>
      </div>
      {lista.length === 0
        ? <div style={{ color: "#94a3b8", fontSize: 13.5, padding: "4px 2px 8px" }}>Sin cambios en el catálogo.</div>
        : lista.map((d, i) => <BloqueDia key={d.dia} d={d} abiertoInicial={i === 0 && titulo.startsWith("Esta")} />)}
    </div>
  );

  return (
    <>
      <button onClick={() => setAbierto(true)} style={{
        width: "90%", maxWidth: 400, margin: "0 auto 18px", display: "block", padding: "12px 14px",
        borderRadius: 16, cursor: "pointer", textAlign: "left",
        border: pendientes ? "2px solid #22c55e" : "1px solid #e2e8f0",
        background: pendientes ? "linear-gradient(135deg,#f0fdf4,#ecfeff)" : "#f8fafc",
        boxShadow: pendientes ? "0 4px 14px rgba(34,197,94,0.18)" : "none",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 20 }}>🆕</span>
          <span style={{ flex: 1, fontWeight: 900, fontSize: 15, color: "#1e293b" }}>Novedades en productos</span>
          {pendientes > 0
            ? <span style={{ background: "#16a34a", color: "#fff", borderRadius: 999, padding: "3px 10px", fontSize: 12.5, fontWeight: 900, whiteSpace: "nowrap" }}>{pendientes} sin ver</span>
            : <span style={{ color: "#94a3b8", fontSize: 12.5, fontWeight: 700 }}>Ver ›</span>}
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
          <span style={{ background: "#dcfce7", color: "#15803d", borderRadius: 999, padding: "3px 10px", fontSize: 13, fontWeight: 800 }}>
            +{nAltas} nuevos
          </span>
          <span style={{ background: "#fee2e2", color: "#b91c1c", borderRadius: 999, padding: "3px 10px", fontSize: 13, fontWeight: 800 }}>
            −{nBajas} quitados
          </span>
          <span style={{ color: "#64748b", fontSize: 12.5, alignSelf: "center" }}>esta semana</span>
        </div>
        {miniaturas.length > 0 && (
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 8 }}>
            {miniaturas.map((p) => (
              <img key={p.id_producto} src={p.imagen} alt="" loading="lazy" style={{
                width: 38, height: 38, objectFit: "contain", borderRadius: 10, background: "#fff",
                boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
              }} />
            ))}
          </div>
        )}
        {(nAltasAnt > 0 || nBajasAnt > 0) && (
          <div style={{ color: "#94a3b8", fontSize: 12, marginTop: 6 }}>Semana anterior: +{nAltasAnt} nuevos · −{nBajasAnt} quitados</div>
        )}
      </button>

      {abierto && (
        <div onClick={() => setAbierto(false)} style={{
          position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", zIndex: 4000,
          display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "30px 10px", overflowY: "auto",
        }}>
          <div onClick={(e) => e.stopPropagation()} style={{
            background: "#fff", borderRadius: 18, width: "min(560px, 100%)", padding: "16px 14px 12px",
            boxShadow: "0 20px 50px rgba(0,0,0,0.3)", textAlign: "left",
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
              <div style={{ flex: 1, fontSize: 19, fontWeight: 900, color: "#1e3a5f" }}>🆕 Novedades en productos</div>
              <button onClick={() => setAbierto(false)} style={{ border: "none", background: "#f1f5f9", borderRadius: 8, padding: "6px 10px", cursor: "pointer", fontWeight: 800 }}>✕</button>
            </div>
            <Semana titulo={`Esta semana (desde el lunes ${fmtFecha(datos.desde_esta)})`} lista={esta} />
            <Semana titulo={`Semana anterior (desde el ${fmtFecha(datos.desde_anterior)})`} lista={anterior} />
            <button onClick={entendido} disabled={guardando} style={{
              width: "100%", border: "none", borderRadius: 12, padding: "12px 0", background: "#16a34a", color: "#fff",
              fontWeight: 900, fontSize: 15.5, cursor: "pointer", opacity: guardando ? 0.6 : 1, marginTop: 4,
            }}>✓ Entendido</button>
          </div>
        </div>
      )}
    </>
  );
}
